import { Vector3 } from "three";
import { useViewSettings } from "@/view-settings";
import { useSelector } from "@legendapp/state/react";
import { CameraInstances } from "./camera-instances";
import { CameraCalibration } from "@/shared/api";

interface CameraFrustumsProps {
  cameraCalibrations: CameraCalibration[];
  updateControlTarget: (vector: Vector3) => void;
}

export function CameraFrustums({
  cameraCalibrations,
  updateControlTarget,
}: CameraFrustumsProps) {
  const viewSettings = useViewSettings();
  const showCamera = useSelector(() => viewSettings.showCamera.get());

  if (!showCamera || !cameraCalibrations) {
    return null;
  }

  return (
    <CameraInstances
      updateControlTarget={updateControlTarget}
      cameras={cameraCalibrations}
    />
  );
}
